import React, { Component } from "react";

class BannerDetailsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="lg:px-0 md:px-0 px-5">
        <card className="w-full drop-shadow flex rounded-12px mt-6 mb-12  lg:py-8 md:py-8 sm-p-4">
          <div className="lg:flex md:flex items-center w-full">
            <div className="lg:w-1/4 md:w-1/4 w-full border2px-f5f5f5-r flex lg:mb-0 md:mb-0 mb-4  lg:justify-center">
              <div className="lg:px-8 md:px-8">
                <h1 className="fsize24 sm-fsize16 text262626 font-bold ">
                  Flexible deadlines
                </h1>
                <p className="text707070 fsize16 sm-fsize14 line-h24 line-clamp-2 mt-1">
                  Reset deadlines in accordance to your schedule.
                </p>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/4 border2px-f5f5f5-r flex  lg:justify-center lg:mb-0 md:mb-0 mb-4">
              <div className="lg:px-8 md:px-8">
                <h1 className="fsize24 sm-fsize16 text262626 font-bold ">
                  Shareable Certificate
                </h1>
                <p className="text707070 fsize16 sm-fsize14 line-h24 line-clamp-2 mt-1">
                  Earn a Certificate upon completion
                </p>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/4 border2px-f5f5f5-r flex  lg:justify-center lg:mb-0 md:mb-0 mb-4">
              <div className="lg:px-8 md:px-8">
                <h1 className="fsize24 sm-fsize16 text262626 font-bold ">
                  100% Online
                </h1>
                <p className="text707070 fsize16 sm-fsize14 line-h24 line-clamp-2 mt-1">
                  Start instantly and learn at your own schedule
                </p>
              </div>
            </div>

            <div className="lg:w-1/4 md:w-1/4  flex  lg:justify-center lg:mb-0 md:mb-0 mb-4">
              <div className="lg:px-8 md:px-8">
                <h1 className="fsize24 sm-fsize16 text262626 font-bold ">
                  English
                </h1>
                <p className="text707070 fsize16 sm-fsize14 line-h24 line-clamp-2 mt-1">
                  Subtitles: English, French, Portuguese, German
                </p>
              </div>
            </div>
          </div>
        </card>
      </div>
    );
  }
}
export default BannerDetailsCard;
